
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"64","height":"65","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#74DBB5","d":"M24 15.061h29v30H24zM7 15.061h16v30H7z"}}),_c('path',{attrs:{"d":"M38.267 24.194a5.662 5.662 0 00-5.667 5.667 5.662 5.662 0 005.667 5.667 5.662 5.662 0 005.666-5.667 5.662 5.662 0 00-5.666-5.667z","fill":"#1E1E1E"}}),_c('path',{attrs:{"d":"M56.467 5.061H7.533c-4 0-7.2 3.267-7.2 7.2v35.4c0 4 3.267 7.2 7.2 7.2H9.6l.8 3.2c.267 1 1.133 1.667 2.133 1.667h7c1 0 1.8-.667 2.067-1.6l.8-3.2h19.2l.8 3.2a2.22 2.22 0 002.133 1.6h7c1 0 1.8-.667 2.067-1.6l.8-3.2h2.067c4 0 7.2-3.267 7.2-7.2V12.26c0-3.933-3.267-7.2-7.2-7.2zM11.333 17.528c0-1.134.934-2.067 2.067-2.067s2.067.933 2.067 2.067v25a2.077 2.077 0 01-2.067 2.066c-1.133 0-2.067-1-2.067-2.133V17.528zM40.2 42.194a2.077 2.077 0 01-2.067 2.067 2.077 2.077 0 01-2.066-2.067v-2.733c-1.134-.267-2.267-.733-3.2-1.4l-1.934 1.933c-.4.4-.933.6-1.466.6-.534 0-1.067-.2-1.467-.6-.8-.8-.8-2.133 0-2.933l2-2c-.6-1-1.067-2.067-1.267-3.2h-2.8a2.077 2.077 0 01-2.066-2.067c0-1.133.933-2.066 2.066-2.066H28.8c.267-1.134.733-2.2 1.333-3.2l-2-2c-.8-.8-.8-2.134 0-2.934.8-.8 2.134-.8 2.934 0l2 2c.933-.6 2.066-1.066 3.2-1.333v-2.8c0-1.133.933-2.067 2.066-2.067 1.134 0 2.067.934 2.067 2.067v2.8c1.2.267 2.267.733 3.2 1.333l1.933-1.933c.8-.8 2.134-.8 2.934 0 .8.8.8 2.133 0 2.933l-1.934 1.934c.667 1 1.134 2.066 1.334 3.266h2.666c1.134 0 2.067.934 2.067 2.067a2.077 2.077 0 01-2.067 2.067h-2.666a9.515 9.515 0 01-1.4 3.266l1.866 1.867c.8.8.8 2.133 0 2.933-.4.4-.933.6-1.466.6-.534 0-1.067-.2-1.467-.6l-1.933-1.933c-1 .6-2.067 1.067-3.267 1.333v2.8z","fill":"#1E1E1E"}})])
          )
        }
      }
    